import { useTranslation } from "react-i18next";
import Logo from "../../ui/HeaderBar/Logo";
import { Button, Seperator } from "./SpectatorJoinMenu";

import { useSpring, animated, config } from "@react-spring/web";
import { useEffect, useRef, useState } from "react";

const SessionEndScreen = ({ ...props }) => {
  const { t } = useTranslation();

  const handleCreateClick = () => {
    window.open(t("BUTTON_GET_IN_TOUCH_URL"), "_blank").focus();
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        zIndex: 9999999999998,
        background: "black",
        color: "white",
      }}
    >
      <Logo />

      <div style={{ height: `${24 * 4}px` }}></div>
      <h1
        style={{
          margin: 0,
          fontSize: "30px",
          fontWeight: 300,
        }}
      >
        {t("MULTIUSER_END")}
      </h1>

      <div style={{ height: `${24 * 1}px` }}></div>
      <h2
        style={{
          width: "450px",
          fontWeight: 300,
          color: "#A7A7A7",
          textAlign: "center",
          fontSize: "18px",
          lineHeight: "20px",
          margin: 0,
        }}
      >
        {t("MULTIUSER_END_SUBLINE")}
      </h2>

      <div style={{ height: `${18}px` }}></div>

      <Seperator />
      {/* <div style={{ height: `${24 * 6}px` }}></div> */}

      <div style={{ height: `${18}px` }}></div>

      <p
        style={{
          width: "250px",
          fontWeight: 300,
          color: "#A7A7A7",
          textAlign: "center",
          fontSize: "12px",
          lineHeight: "16px",
          margin: 0,
        }}
      >
        {t("MULTIUSER_END_CREATE_SUBLINE")}
      </p>

      <div style={{ height: `${18}px` }}></div>

      <Button textId="MULTIUSER_END_CREATE" onClick={handleCreateClick} />

      <div style={{ height: `${18}px` }}></div>

      <Seperator />

      <div style={{ height: `${18}px` }}></div>

      <p
        style={{
          width: "200px",
          fontWeight: 300,
          color: "#A7A7A7",
          textAlign: "center",
          fontSize: "12px",
          lineHeight: "16px",
          margin: 0,
        }}
      >
        {t("MULTIUSER_END_VISIT")}
      </p>

      <div style={{ height: `${12}px` }}></div>

      <LinkButton />

      <div style={{ height: `${18}px` }}></div>
    </div>
  );
};

const LinkButton = ({ textId = "button", onClick = () => {}, ...props }) => {
  const { t } = useTranslation();

  const [hovered, setHovered] = useState(false);

  const { backgroundColor } = useSpring({
    backgroundColor: hovered ? "#444444" : "#000000",
    config: config.stiff,
  });

  const handleClick = () => {
    window.open("https://www.enrx.com/", "_blank").focus();
  };

  return (
    <animated.div
      onClick={(e) => {
        handleClick();
      }}
      style={{
        color: "#fff",
        textAlign: "center",
        width: "max-content",
        fontSize: "18px",
        fontWeight: 500,
        padding: "11px",
        paddingLeft: "20px",
        paddingRight: "20px",
        border: "2px solid white",
        // paddingTop: "11px",
        // paddingBottom: "11px",
        pointerEvents: "auto",
        transition: "boxShadow 0.9s linear",
        borderRadius: "3px",
        cursor: "pointer",
        opacity: 1,
        backgroundColor: backgroundColor,
        display: "flex",
        alignItems: "center",
        minWidth: "60px",
        display: "flex",
        justifyContent: "center",
      }}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
    >
      www.enrx.com
    </animated.div>
  );
};

export default SessionEndScreen;
